"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SftpAccountFilterDto = void 0;
const shared_1 = require("../shared");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const boolean_transform_1 = require("../../constants/boolean.transform");
class SftpAccountFilterDto extends shared_1.PaginationOptionsDto {
    constructor(sftpAccountFilterOptions) {
        super();
        if (sftpAccountFilterOptions && sftpAccountFilterOptions.schoolId)
            this.schoolId = sftpAccountFilterOptions.schoolId;
        if (sftpAccountFilterOptions && sftpAccountFilterOptions.schoolGroupId)
            this.schoolGroupId = sftpAccountFilterOptions.schoolGroupId;
        if (sftpAccountFilterOptions && sftpAccountFilterOptions.groupLevel)
            this.groupLevel = sftpAccountFilterOptions.groupLevel;
    }
    schoolId;
    schoolGroupId;
    groupLevel;
}
exports.SftpAccountFilterDto = SftpAccountFilterDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Type)(() => Number),
    __metadata("design:type", Number)
], SftpAccountFilterDto.prototype, "schoolId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Type)(() => Number),
    __metadata("design:type", Number)
], SftpAccountFilterDto.prototype, "schoolGroupId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(boolean_transform_1.BooleanStringTransform),
    __metadata("design:type", Boolean)
], SftpAccountFilterDto.prototype, "groupLevel", void 0);
